
import { Component, Prop } from "vue-property-decorator";
import { MR } from "@/store/modules";
import { mixins } from "vue-class-component";
import { MRErrorMixin } from "./MRErrorMixin";

@Component
export class MRApproveButton extends mixins(MRErrorMixin) {
  @Prop(MR)
  private record!: MR;

  @Prop(Boolean)
  loading = false;

  savingText = "Saving";

  get isApproved() {
    // return false;
    return this.record.approved;
  }

  get text() {
    return this.record.approved ? "Disapprove" : "Approve";
  }

  approve() {
    this.$bvModal
      .msgBoxConfirm(`Are you sure you want to ${this.text} this MR?`, {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "YES",
        cancelTitle: "NO",
        footerClass: "p-2",
        hideHeaderClose: true,
        centered: true,
      })
      .then((state: boolean) => {
        if (!state) {
          return;
        }
        return this.$nextTick(() => this.approveMR());
      });
  }

  async approveMR() {
    // this.loading = true;
    try {
      await MR.dispatch("approve", {
        id: this.record.id,
      });
    } catch (err) {
      console.error("Error occured", err, this);
    }

    // if (!this.hasError()) {
    //   this.$root.$bvToast.toast(`Record has been updated`, {
    //     title: "Saving",
    //     variant: "success",
    //   });
    //   this.loading = false;
    //   return;
    // }

    // this.$root.$bvToast.toast(`Failed to save MR`, {
    //   title: "Error",
    //   variant: "danger",
    // });

    // this.loading = false;
  }
}

export default MRApproveButton;
